var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectClickToPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 20,
    viewBox: "0 0 33 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7242_15099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0198 19.8463C28.1178 19.8463 32.2506 15.7135 32.2506 10.6155C32.2506 5.51752 28.1178 1.38477 23.0198 1.38477C17.9218 1.38477 13.7891 5.51752 13.7891 10.6155C13.7891 15.7135 17.9218 19.8463 23.0198 19.8463Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1433 7.03872C26.2918 6.89565 26.5274 6.89669 26.6747 7.04106L29.3433 10.2822C29.5295 10.4646 29.5276 10.7648 29.3392 10.9449L26.7214 14.2118C26.6569 14.2735 26.571 14.308 26.4817 14.308H24.2837C23.9739 14.308 23.8198 13.9329 24.0403 13.7155L26.7226 10.6156L24.2837 7.61565H23.3053L25.6379 10.2823C25.8282 10.464 25.8284 10.7675 25.6382 10.9494L22.5734 14.2118C22.5089 14.2735 22.4231 14.308 22.3338 14.308H18.866C18.1015 14.308 17.4817 13.6883 17.4816 12.9238C17.4813 11.3852 17.4815 9.84654 17.4817 8.30789C17.4817 7.54322 18.1016 6.92334 18.8663 6.92334H20.2437C20.4351 6.92334 20.5902 7.07829 20.5902 7.26949C20.5902 7.46069 20.4351 7.61565 20.2437 7.61565H19.0979C18.5881 7.61565 18.1748 8.02894 18.1748 8.53872C18.1748 9.92334 18.1748 11.308 18.1748 12.6926C18.1748 13.2024 18.5881 13.6156 19.0979 13.6156H22.0773L24.8744 10.6156L22.1921 7.51583C21.9716 7.29848 22.1257 6.92334 22.4355 6.92334H24.5779C24.6672 6.92334 24.7531 6.9578 24.8176 7.01946L27.4864 10.2819C27.6766 10.4638 27.6764 10.7673 27.4861 10.949L25.1534 13.6156H26.1933L28.5708 10.6156L26.1433 7.61565C25.9912 7.46531 25.9893 7.18709 26.1433 7.03872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71154 0.154001L19.3694 0.153809C18.1547 0.577534 17.0365 1.20682 16.0563 1.99998L3.32692 2.00015C2.64719 2.00015 2.09615 2.55119 2.09615 3.23092V14.2879C2.09615 14.9786 2.65607 15.5385 3.34678 15.5385H13.0938C13.4192 16.1933 13.8075 16.8113 14.2508 17.3847H2.85633C1.4169 17.3847 0.25 16.2178 0.25 14.7784V2.61554C0.25 1.25607 1.35207 0.154001 2.71154 0.154001ZM8.86539 9.38458C9.20526 9.38458 9.48077 9.10907 9.48077 8.76919V5.07689C9.48077 4.73702 9.20526 4.4615 8.86539 4.4615H5.17308C4.83321 4.4615 4.55769 4.73702 4.55769 5.07689V8.76919C4.55769 9.10907 4.83321 9.38458 5.17308 9.38458H8.86539Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7242_15099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 19.6923,
    fill: "white",
    transform: "translate(0.25 0.153809)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectClickToPay);
export default __webpack_public_path__ + "static/media/directClickToPay.b71b746b1083a0ab1f54d2f178a1177f.svg";
export { ForwardRef as ReactComponent };